import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { skipToken } from '@reduxjs/toolkit/query';
import { Box } from '@mui/material';
import { DEFAULT_FILTERS } from '../../../widgets/logistics/advices/constants/filters';
import prepareFilterParams from './utils/prepareFilterParams';
import {
  useGetLogisticAdvicesCountQuery,
  useGetLogisticAdvicesQuery,
} from '../../../entities/logistic/logisticTasks/redux/logisticTasks.api';
import AdvicesLoadingWidget from '../../../widgets/logistics/advices/AdvicesLoadingWidget/AdvicesLoadingWidget';
import AdvicesToolbarWidget from '../../../widgets/logistics/advices/AdvicesToolbarWidget/AdvicesToolbarWidget';
import AdvicesFiltersWidget from '../../../widgets/logistics/advices/AdvicesFiltersWidget/AdvicesFiltersWidget';
import AdvicesTableWidget from '../../../widgets/logistics/advices/AdvicesTableWidget/AdvicesTableWidget';

const POLL_INTERVAL = 30_000; // 30 секунд

function AdvicesPanel() {
  const queryParams = useParams();
  const logisticTaskId = parseInt(queryParams.logisticTaskId, 10);

  const [isFiltersOpen, setIsFiltersOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [filters, setFilters] = useState(DEFAULT_FILTERS);

  const params = useMemo(
    () => prepareFilterParams(logisticTaskId, filters, rowsPerPage, page),
    [logisticTaskId, filters, rowsPerPage, page],
  );

  const { data: advices = [], isLoading } = useGetLogisticAdvicesQuery(logisticTaskId ? { params } : skipToken, {
    refetchOnMountOrArgChange: true,
    pollingInterval: POLL_INTERVAL,
  });

  const { data: advicesTotalCount } = useGetLogisticAdvicesCountQuery(logisticTaskId ? { params } : skipToken, {
    refetchOnMountOrArgChange: true,
  });

  const toogleFilters = () => {
    setIsFiltersOpen((prev) => !prev);
  };

  const handleChangePage = (_, value) => {
    setPage(value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (isLoading || !logisticTaskId) {
    return <AdvicesLoadingWidget />;
  }

  return (
    <Box sx={{ p: 2 }}>
      <AdvicesToolbarWidget toogleFilters={toogleFilters} />
      <AdvicesFiltersWidget isOpen={isFiltersOpen} filters={filters} setFilters={setFilters} setPage={setPage} />

      <AdvicesTableWidget
        advices={advices}
        count={advicesTotalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
}

export default AdvicesPanel;
